import { Api } from "../../../../src/components/Api";
import * as React from 'react';
export default {
  Api,
  React
};